import { size } from "polished";
import * as React from "react";
import styled from "styled-components";
import { IElement } from "core-integration/src/store/elements/types";
import Info from "../img/icons/info.svg?react";
import Status from "../img/icons/status.svg?react";

const StyledInfo = styled(Info)`
  ${size(14)}
  display: block;
  margin: auto;
  fill: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.blackLighter};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

const StyledStatus = styled(Status)<{ copnr: number }>`
  ${size(14)}
  display: block;
  margin: auto;
  fill: ${(props) => props.theme.colors.elementStatus[props.copnr].bg};
  color: ${(props) => props.theme.colors.elementStatus[props.copnr].color};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

interface IProps {
  element: IElement;
}

const ElementStatus: React.FC<IProps> = ({ element }) => {
  let copnr: number = 50;
  if (element.chance_of_playing_next_round !== null) {
    copnr = element.chance_of_playing_next_round;
  }

  return element.news ? <StyledStatus copnr={copnr} /> : <StyledInfo />;
};

export default ElementStatus;
